const CHUNK_ERRORS = [
  'Failed to fetch dynamically imported module', // Chromium
  'error loading dynamically imported module', // Firefox
  'Importing a module script failed', // Safari
  'Unable to preload CSS', // Vite's preload helper
];

/** A lazily loaded screen's code could not be fetched (offline, or a new deploy removed it). */
export function isChunkLoadError(error: unknown): boolean {
  const message = error instanceof Error ? error.message : '';
  return CHUNK_ERRORS.some((start) => message.includes(start));
}
